import { useFieldArray, useFormContext } from 'react-hook-form';

import { Tooltip } from 'primereact/tooltip';
import PropTypes from 'prop-types';
import { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { classNames } from 'primereact/utils';
import UsefulSolutionDialog from './UsefulSolutionDialog';

export default function UsefulSolutionsTable({ control, shouldUpdateFromDocx }) {
  // #region Data
  const { t } = useTranslation();

  const usefulSolutionRef = useRef();
  const { dirtyFields } = useFormContext();

  const { fields, insert, update, remove } = useFieldArray({
    control,
    name: 'others.usefulSolutions',
  });
  // #endregion
  // #region Event

  // #endregion
  return (
    <>
      <div className="form-table mt-2">
        <table className="mb-2">
          <thead>
            <tr>
              <th className="text-center" style={{ minWidth: 50, width: 50 }}>
                {t('formLayout.numericalOrder')}
              </th>
              <th className="text-center" style={{ minWidth: 250, width: '25%' }}>
                {t('scientificProfile.otherInfo.usefulSolution.name')}
              </th>
              <th className="text-center" style={{ minWidth: 110, width: '11%' }}>
                {t('scientificProfile.otherInfo.usefulSolution.projectCode')}
              </th>
              <th className="text-center" style={{ minWidth: 100, width: '10%' }}>
                {t('scientificProfile.otherInfo.usefulSolution.number')}
              </th>
              <th className="text-center" style={{ minWidth: 70, width: '7%' }}>
                {t('scientificProfile.otherInfo.usefulSolution.yearOfIssue')}
              </th>
              <th className="text-center" style={{ minWidth: 250, width: '25%' }}>
                {t('scientificProfile.otherInfo.usefulSolution.placeOfIssue')}
              </th>
              <th className="text-center" style={{ minWidth: 120, width: '12%' }}>
                {t('scientificProfile.otherInfo.usefulSolution.authorOrCoauthor')}
              </th>
              <th className="text-center float" style={{ minWidth: 80, width: 80 }}>
                {t('formLayout.action.label')}
              </th>
            </tr>
          </thead>
          <tbody>
            {fields?.map((item, index) => (
              <tr
                key={item.id ?? index}
                className={classNames({
                  highlighted: shouldUpdateFromDocx && dirtyFields.others?.usefulSolutions,
                })}
              >
                <td className="text-center">{index + 1}</td>
                <td>{item?.name}</td>
                <td>{item?.projectCode}</td>
                <td>{item?.number}</td>
                <td>{item?.yearOfIssue}</td>
                <td>{item?.placeOfIssue}</td>
                <td>
                  {item?.contributorRole ? t(`contributorRole.${item?.contributorRole}`) : ''}
                </td>

                <td
                  className={`flex flex-column float text-center p-0 border-none ${
                    index !== 0 ? 'border-top-1' : ''
                  }`}
                >
                  <i
                    onClick={() => {
                      usefulSolutionRef.current.open({
                        insert,
                        index: index + 1,
                        type: 'INSERT',
                      });
                    }}
                    className="insert-icon pi pi-plus text-primary cursor-pointer my-1"
                    data-pr-tooltip={t('formLayout.action.insert')}
                    data-pr-position="left"
                  />
                  <Tooltip target=".insert-icon" />

                  <i
                    onClick={() => {
                      usefulSolutionRef.current.open({
                        update,
                        index,
                        value: fields[index],
                        type: 'UPDATE',
                      });
                    }}
                    className="edit-icon pi pi-pencil text-primary cursor-pointer mb-1"
                    data-pr-tooltip={t('formLayout.action.edit')}
                    data-pr-position="left"
                  />
                  <Tooltip target=".edit-icon" />

                  <i
                    onClick={() => remove(index)}
                    className="remove-icon pi pi-times text-red-700 cursor-pointer mb-1"
                    data-pr-tooltip={t('formLayout.action.remove')}
                    data-pr-position="left"
                  />
                  <Tooltip target=".remove-icon" />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        {fields?.length === 0 && (
          <div className="flex justify-content-center my-2">
            <i
              onClick={() => {
                usefulSolutionRef.current.open({
                  insert,
                  index: 0,
                  type: 'INSERT',
                });
              }}
              className="add-useful-solution pi pi-plus text-primary cursor-pointer bg-primary p-1 border-circle"
              data-pr-tooltip={t('formLayout.action.add')}
              data-pr-position="left"
            />
            <Tooltip target=".add-useful-solution" />
          </div>
        )}
      </div>
      <UsefulSolutionDialog ref={usefulSolutionRef} />
    </>
  );
}

UsefulSolutionsTable.propTypes = {
  control: PropTypes.shape({}).isRequired,
  errors: PropTypes.shape({}).isRequired,
  shouldUpdateFromDocx: PropTypes.bool,
};

UsefulSolutionsTable.defaultProps = {
  shouldUpdateFromDocx: false,
};
